import React from 'react'
import './_category.scss'
import {get} from 'lodash/fp'

import MetaData from '../../components/meta-data'
let categories = require('../../data/code/blog-categorys.json')
  .map(item => ({...item, imageURL: get('image.fields.file.url', item)}))
  .reduce((r, item) => ({...r, [item.name]: item}), {})

export const categoryToURL = (category) => '/blog/category/' + categories[category].id

class BlogCategory extends React.Component {
  render(){
    return (
      <div className='category'>
        <MetaData data={{
          slug:'blog/category',
          title: 'Coding Categories from the Blog | Code Fellows',
          description: 'Blog Categories',
        }} />
        <h2 style={{paddingTop: '1.5em', paddingBottom: '1.5em'}} >Categories</h2>
        <div className='category-list'>
          {Object.keys(categories).sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1).map((category, key) => 
            <a href={categoryToURL(category)} key={key} className='category-item'>
              <img src={categories[category].imageURL} />
              <h3>{category}</h3>
            </a>
          )}
          <span className='clearfix' />
        </div>
      </div>
    )
  }
}

export default BlogCategory



// WEBPACK FOOTER //
// ./src/templates/category/index.js